import { useGetCurrentClientLocationMutation } from "@workspace/casino_core/mutations/GetCurrentClientLocationMutation.client";

const useCurrentClientLocation = () => {
  const [getCurrentClientLocation] = useGetCurrentClientLocationMutation();
  return { getCurrentClientLocation };
};

export default useCurrentClientLocation;
